export default __webpack_public_path__ + "static/media/carpediembes2.46aed098.jpg";